export type MessageAlignment = 'left' | 'right';

export type MediaContainerSpacing = {
  mt: number;
  mb: number;
  ml: number;
  mr: number;
};

export function getMediaContainerSpacing(direction: MessageAlignment): MediaContainerSpacing {
  return {
    mt: 0.5,
    mb: 0.5,
    ml: direction === 'left' ? 1 : 0,
    mr: direction === 'right' ? 2 : 1,
  };
}

export function getFooterTopMargin(hasMediaUrls: boolean): number {
  return hasMediaUrls ? 0.5 : 1;
}
